import create from 'zustand';
import { persist } from 'zustand/middleware';

import { ReviewSeverity } from 'api/journey-reviews/requests';

export type OpenBySeverity = Partial<Record<ReviewSeverity, boolean>>;

type ReviewGroupsStore = {
  openByJourney: Record<string, OpenBySeverity>;
  setGroupOpen: (group: {
    journeyShortId: string;
    severity: ReviewSeverity;
    isOpen: boolean;
  }) => void;
};

export const useReviewGroupsStore = create(
  persist<ReviewGroupsStore>(
    (set) => ({
      openByJourney: {},
      setGroupOpen: ({ journeyShortId, severity, isOpen }) =>
        set((state) => ({
          openByJourney: {
            ...state.openByJourney,
            [journeyShortId]: { ...state.openByJourney[journeyShortId], [severity]: isOpen },
          },
        })),
    }),
    { name: 'journey-review-groups', getStorage: () => sessionStorage },
  ),
);

export const isGroupOpen = (openBySeverity: OpenBySeverity | undefined, severity: ReviewSeverity) =>
  openBySeverity?.[severity] ?? severity !== 'improvement';
